import React from "react";
import { Stack } from "../../../Stacks/Stack/Stack";
import { OperationalContent, OperationalContentProps } from "../shared/OperationalContent";

export const EmptyColumn: React.FC<OperationalContentProps> = ({ operationalData }) => (
    <Stack horizontalAlign="start">
        <OperationalContent
            operationalData={operationalData}
        />
    </Stack>

);
